import React from 'react';

const SvgTransitTracker = ({ title, ...props }) => (
  <svg viewBox="0 0 50 50" {...props}>
    {title ? <title>{title}</title> : null}
    <circle
      cx={25}
      cy={25}
      r={22}
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path
      d="M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm11.6 33.9l-13.5-7.8V6H27v17.8l11.6 6.7-2 3.4z"
      fill="#008ab0"
    />
  </svg>
);

export default SvgTransitTracker;
